import { ApiResponse, TicketReportingOption, TicketReportingOptionsArgs } from '@vision/ui/interfaces';
import { TicketManagerApi } from '../ticket-manager.api';
import { normalizeTicketReportingOptionsResponse } from './reporting-options.mappers';
import { buildGetTicketReportingOptionsRequest } from './reporting-options.routes';

export const TicketReportingOptionsEndpoints = TicketManagerApi.injectEndpoints({
  endpoints: (builder) => ({
    ticketReportingOptions: builder.query<ApiResponse<TicketReportingOption[]>, TicketReportingOptionsArgs>({
      query: buildGetTicketReportingOptionsRequest,
      transformResponse: normalizeTicketReportingOptionsResponse,
    }),
  }),
});

export const { useLazyTicketReportingOptionsQuery } = TicketReportingOptionsEndpoints;
